const withContext = (useContextHook) => (Component) => (props) => {
    if (useContextHook && typeof useContextHook === 'function') {
        const withContextValue = useContextHook();
        return <Component {...(props || {})} {...(withContextValue || {})} />;
    }

    return <Component {...props} />;
};

export default withContext;
